import type { ResumoDashboard } from "../../../services/resumoFornecedor"

export enum ResumoFornecedorActionsTypes {
    CARREGAR = "CARREGAR",
    ATUALIZAR_DATAS = "ATUALIZAR_DATAS",
}

export type ResumoFornecedorAction =
    | { type: ResumoFornecedorActionsTypes.CARREGAR; payload: ResumoDashboard }
    | { type: ResumoFornecedorActionsTypes.ATUALIZAR_DATAS; payload: { dataInicio: string; dataFim: string } }
